"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelect = void 0;
var react_1 = require("react");
var debounce_1 = __importDefault(require("../../utility/debounce"));
function isSelectOptionOrGroup(option) {
    return typeof option === "object" && ("value" in option || "heading" in option);
}
function optionContainsQuery(option, query) {
    // TODO this doesn't handle accents, but code could be written to do that if needed.
    var subject = (option.label + " " + option.value).trim().toLowerCase();
    return subject.indexOf(query.trim().toLowerCase()) > -1;
}
function filterOptions(options, query, optionPredicate) {
    if (optionPredicate === void 0) { optionPredicate = optionContainsQuery; }
    var results = [];
    // Simple text search based on label, then value.
    options.forEach(function (option) {
        // Searching a regular option
        if (isSelectOptionOrGroup(option) && "value" in option) {
            if (optionPredicate(option, query)) {
                results.push(option);
            }
        }
        else {
            // Searching an option group.
            var filteredGroupOptions_1 = [];
            option.options.forEach(function (groupOption) {
                if (optionContainsQuery(groupOption, query)) {
                    filteredGroupOptions_1.push(groupOption);
                }
            });
            if (filteredGroupOptions_1.length) {
                results.push(__assign(__assign({}, option), { options: filteredGroupOptions_1 }));
            }
        }
    });
    return results;
}
var useSelect = function (configuration) {
    var _a;
    var _b = react_1.useState(false), isSearching = _b[0], setIsSearching = _b[1];
    var _c = react_1.useState(""), searchQuery = _c[0], setSearchQuery = _c[1];
    var searchableInputEl = react_1.useRef(null);
    var _d = react_1.useState(), highlightedEl = _d[0], setHighlightedEl = _d[1];
    var _e = react_1.useState(true), scrollIntoView = _e[0], setScrollIntoView = _e[1];
    var _f = react_1.useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = react_1.useState(), highlightedOption = _g[0], setHighlightedOption = _g[1];
    var _h = react_1.useState(false), isFocussed = _h[0], setIsFocussed = _h[1];
    var builtInitialOptions = react_1.useMemo(function () {
        if (!configuration.initialOptions) {
            return [];
        }
        var outputOptions = [];
        configuration.initialOptions.forEach(function (initialOption) {
            if (isSelectOptionOrGroup(initialOption)) {
                outputOptions.push(initialOption);
            }
            else {
                outputOptions.push({ value: initialOption });
            }
        });
        return outputOptions;
    }, [configuration.initialOptions]);
    var _j = react_1.useState(builtInitialOptions), options = _j[0], setOptions = _j[1];
    var optionCache = react_1.useRef({
        "": builtInitialOptions,
    });
    /**
     * Option invalidation.
     *
     * If the parent component changes `initialOptions` or `optionsDependsOn`,
     * then Select state needs to be reset.
     *
     * This can be used to change options dynamically, such as forms with
     * refining Selects.
     */
    var isFirstRun = react_1.useRef(true);
    // Build our list of dependencies for our useEffect.
    var resetOptionDependencies = [configuration.initialOptions];
    // If additional dependencies have been passed, let's add them to our list
    if (configuration.optionsDependOn) {
        resetOptionDependencies = resetOptionDependencies.concat(configuration.optionsDependOn);
    }
    react_1.useEffect(function () {
        // No need to do anything on first render - doing so would cause a needless
        // rerender.
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        setOptions(builtInitialOptions);
    }, resetOptionDependencies);
    // Flatten grouped option sets into a simple list.
    var flattenedOptions = react_1.useMemo(function () {
        var flatOptions = [];
        options.forEach(function (option) {
            if ("options" in option) {
                option.options.forEach(function (subOption) { return flatOptions.push(subOption); });
            }
            else {
                flatOptions.push(option);
            }
        });
        return flatOptions;
    }, [options]);
    var _k = react_1.useState([]), selectedOptions = _k[0], setSelectedOptions = _k[1];
    // INITIALISATION
    react_1.useEffect(function () {
        var valueToUse = configuration.value || configuration.defaultValue;
        if (valueToUse !== undefined) {
            var initiallySelected = Array.isArray(valueToUse) ? valueToUse : [valueToUse];
            var initiallySelectedOptions_1 = [];
            var fetchedOptions_1 = [];
            // Map initially selected values to options that may already be supplied.
            initiallySelected.forEach(function (selectedValue) {
                if (isSelectOptionOrGroup(selectedValue) && "value" in selectedValue) {
                    initiallySelectedOptions_1.push(selectedValue);
                    /**
                     * If a value comes through as a full SelectOption, then add it to the options array,
                     * but only if there isn't already an option with the same value.
                     */
                    if (!flattenedOptions.find(function (option) { return option.value === selectedValue.value; })) {
                        fetchedOptions_1.push(selectedValue);
                    }
                    return;
                }
                var optionWithValue = flattenedOptions.find(function (option) { return option.value === selectedValue; });
                // If the initially selected value is available, use it
                if (optionWithValue) {
                    initiallySelectedOptions_1.push(optionWithValue);
                }
                else {
                    // If the initially selected value is NOT available, try to get it
                    if (configuration.getItemForValue) {
                        var fetchedItem = configuration.getItemForValue(selectedValue);
                        initiallySelectedOptions_1.push(fetchedItem);
                        fetchedOptions_1.push(fetchedItem);
                    }
                    else {
                        // If all else fails, create an option with the value set as is.
                        // This may not look the best in a real select input, but it's a last resort
                        // to ensure that selected values are shown properly
                        initiallySelectedOptions_1.push({ value: selectedValue });
                    }
                }
            });
            setOptions(__spreadArray(__spreadArray([], options), fetchedOptions_1));
            /**
             * Set the selected options to the default value if there are no
             * other selected options, or there is a value that's controlling
             * the component
             */
            if (selectedOptions.length === 0 || configuration.value) {
                setSelectedOptions(initiallySelectedOptions_1);
            }
        }
        else {
            setSelectedOptions([]);
        }
    }, [configuration.defaultValue, configuration.value]);
    react_1.useEffect(function () {
        var _a;
        if (configuration.autoFocus || isOpen) {
            (_a = searchableInputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
            setIsFocussed(true);
        }
    }, [searchableInputEl, configuration.autoFocus, isOpen]);
    // This effect keeps the searchable input element focussed when
    react_1.useEffect(function () {
        var _a;
        if (isFirstRun.current) {
            return;
        }
        if (isOpen) {
            (_a = searchableInputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen]);
    react_1.useEffect(function () {
        if (scrollIntoView && highlightedEl && highlightedEl.parentElement) {
            var parentRect = highlightedEl.parentElement.getBoundingClientRect();
            var highlightedRect = highlightedEl.getBoundingClientRect();
            if (highlightedRect.bottom > parentRect.bottom) {
                highlightedEl.scrollIntoView(false);
            }
            else if (highlightedRect.top < parentRect.top) {
                highlightedEl.scrollIntoView(true);
            }
        }
        setScrollIntoView(false);
    }, [highlightedEl]);
    // STATE MANAGEMENT
    var isAllSelected = react_1.useMemo(function () {
        return flattenedOptions.every(function (option) { return selectedOptions.includes(option); });
    }, [flattenedOptions, selectedOptions]);
    var getAndSetOptionsDebounced = react_1.useCallback(debounce_1.default(function (query, refetch) {
        if (refetch === void 0) { refetch = configuration.refreshOptionsOnSearch; }
        setSearchQuery(query);
        var asyncFn = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!configuration.getOptions) return [3 /*break*/, 2];
                        setIsSearching(true);
                        return [4 /*yield*/, configuration.getOptions(query)];
                    case 1:
                        results = _a.sent();
                        setOptions(results);
                        setIsSearching(false);
                        if (configuration.enableCache || query === "") {
                            optionCache.current[query] = results;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        if (configuration.getOptions && refetch) {
            asyncFn();
        }
        else {
            setOptions(filterOptions(optionCache.current[""], query, configuration.filterOptions));
        }
    }, configuration.refreshOptionsOnSearch ? (_a = configuration.searchDebounceMs) !== null && _a !== void 0 ? _a : 200 : 0), [
        optionCache,
        configuration.enableCache,
        configuration.filterOptions,
        configuration.getOptions,
        configuration.refreshOptionsOnSearch,
        configuration.searchDebounceMs,
    ]);
    var open = function () {
        if (configuration.disabled) {
            if (isOpen) {
                close();
            }
            return;
        }
        setIsOpen(true);
        // If there are no initial options supplied, and there is a function
        // to get them, then try to get options
        if ((!configuration.initialOptions && !options.length) ||
            configuration.refreshOptionsOnOpen) {
            getAndSetOptionsDebounced(searchQuery, true);
        }
    };
    var close = function () {
        setIsOpen(false);
        // If search isn't inline, then reset it
        if (configuration.searchable && !configuration.inlineSearch) {
            setSearchQuery("");
            /**
             * Restore initial options before the search, unless there were no
             * initial options.
             */
            if (builtInitialOptions.length !== 0) {
                setOptions(builtInitialOptions);
            }
        }
    };
    var highlightNextOption = function (direction) {
        var options = flattenedOptions;
        if (!highlightedOption && options.length) {
            if (direction === "ArrowUp") {
                setHighlightedOption(options[options.length - 1]);
            }
            else {
                setHighlightedOption(options[0]);
            }
        }
        else {
            var currentlyHighlightedIndex = options.findIndex(function (option) { return option === highlightedOption; });
            var indexToHighlight = 0;
            if (direction === "ArrowUp") {
                indexToHighlight = currentlyHighlightedIndex - 1;
                if (indexToHighlight < 0) {
                    // First item was highlighted, roll over to bottom
                    indexToHighlight = options.length - 1;
                }
            }
            else {
                indexToHighlight = currentlyHighlightedIndex + 1;
                if (indexToHighlight === options.length) {
                    // Last item highlighted, roll over to top
                    indexToHighlight = 0;
                }
            }
            setHighlightedOption(options[indexToHighlight]);
            setScrollIntoView(true);
        }
    };
    // EVENT HANDLING
    var onKeyDown = function (e) {
        if (configuration.disabled) {
            return;
        }
        switch (e.key) {
            case "ArrowDown":
            // Fall through
            case "ArrowUp":
                if (!isOpen) {
                    open();
                }
                else {
                    /**
                     * preventDefault stops the cursor from moving to the start/
                     * end of the text box when using the arrow keys.
                     */
                    e.preventDefault();
                    highlightNextOption(e.key);
                }
                break;
            case " ": // The space key
                /**
                 * If there is a search box, space shouldn't select the
                 * highlighted option as the user may just want to add a space
                 * to the search query.
                 */
                if (configuration.searchable || configuration.inlineSearch) {
                    if (!isOpen) {
                        open();
                    }
                    // Don't fall through (skips selection behaviour)
                    break;
                    /**
                     * If the space key is pressed and there is no search box,
                     * then fall through to "Enter" behaviour 👇
                     */
                }
            case "Enter":
                if (!isOpen) {
                    open();
                }
                else if (highlightedOption) {
                    onSelect(highlightedOption);
                    e.preventDefault();
                }
                break;
            case "Backspace":
                var lastItem = selectedOptions[selectedOptions.length - 1];
                var queryIsEmpty = searchQuery.length === 0;
                if (lastItem && queryIsEmpty) {
                    onSelect(lastItem);
                }
                break;
            case "Tab":
                if (isOpen) {
                    if (highlightedOption) {
                        onSelect(highlightedOption);
                        e.preventDefault();
                    }
                    close();
                }
                break;
            default:
                setHighlightedOption(undefined);
        }
    };
    /**
     * Trigger passed down `onChange`. If `value` is controlled, this should
     * ideally change `value` in your implementation so the selected options
     * are updated.
     */
    var callOnChange = function (newSelected) {
        if (configuration.onChange) {
            var values = newSelected.map(function (selected) { return selected.value; });
            if (configuration.multiple) {
                //@ts-ignore
                configuration.onChange(values, newSelected);
            }
            else {
                //@ts-ignore
                configuration.onChange(values[0], newSelected[0]);
            }
        }
    };
    var onSelect = function (option) {
        var _a, _b;
        // Don't select or deselect if the option is disabled
        if (option.disabled || configuration.disabled) {
            return;
        }
        var optionIsSelected = selectedOptions.some(function (selectedOption) { return selectedOption.value === option.value; });
        var newSelected;
        if (optionIsSelected && configuration.multiple) {
            /**
             * In multi-select mode, so deselect the value that was clicked if
             * it's already selected.
             */
            newSelected = selectedOptions.filter(function (selectedOption) { return selectedOption.value !== option.value; });
        }
        else {
            if (configuration.multiple) {
                newSelected = __spreadArray(__spreadArray([], selectedOptions), [option]);
            }
            else {
                newSelected = [option];
                close();
            }
            /**
             * If inline search is enabled, clear the value.
             *
             * Otherwise, keep the existing search for queries made inside the
             * dropdown. (more like GitLab multi-select behaviour)
             */
            if (configuration.inlineSearch) {
                setSearchQuery("");
                getAndSetOptionsDebounced(configuration.inlineSearch ? "" : searchQuery);
            }
            (_a = searchableInputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // If the `value` isn't controlled, then set internal state.
        if (configuration.value === undefined) {
            setSelectedOptions(newSelected);
        }
        // Call onChange with newly selected options
        callOnChange(newSelected);
        (_b = searchableInputEl.current) === null || _b === void 0 ? void 0 : _b.focus();
    };
    var onSearchChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newQuery;
        return __generator(this, function (_a) {
            if (configuration.disabled) {
                return [2 /*return*/];
            }
            newQuery = e.target.value;
            setSearchQuery(newQuery);
            if (configuration.enableCache && optionCache.current[newQuery]) {
                setOptions(optionCache.current[newQuery]);
            }
            else {
                getAndSetOptionsDebounced(newQuery);
            }
            if (!isOpen) {
                open();
            }
            return [2 /*return*/];
        });
    }); };
    var onSelectAll = function () {
        if (isAllSelected) {
            setSelectedOptions([]);
        }
        else {
            setSelectedOptions(flattenedOptions);
        }
    };
    /**
     * Clears the list of selected options while leaving pre-selected, disabled
     * options selected.
     */
    var onClearSelection = function () {
        var _a;
        if (configuration.disabled) {
            return;
        }
        /**
         * Anything that was pre-selected and disabled wasn't selected by the
         * user, so it should not be cleared.
         *
         * In the future, you may wish to make this configurable.
         */
        var optionsToKeepSelected = flattenedOptions.filter(function (option) {
            return option.disabled &&
                selectedOptions.some(function (selectedOption) { return option.value === selectedOption.value; });
        });
        setSelectedOptions(optionsToKeepSelected);
        // Call onChange with newly selected options
        callOnChange(optionsToKeepSelected);
        // After clicking the clear selection button, refocus the search box
        (_a = searchableInputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return {
        open: open,
        close: close,
        isOpen: isOpen,
        isFocussed: isFocussed,
        setIsFocussed: setIsFocussed,
        isSearching: isSearching,
        searchQuery: searchQuery,
        onSearchChange: onSearchChange,
        highlightedOption: highlightedOption,
        setHighlightedOption: setHighlightedOption,
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        onClearSelection: onClearSelection,
        options: options,
        isAllSelected: isAllSelected,
        flattenedOptions: flattenedOptions,
        onKeyDown: onKeyDown,
        setHighlightedEl: setHighlightedEl,
        setSearchableInputEl: searchableInputEl,
    };
};
exports.useSelect = useSelect;
//# sourceMappingURL=useSelect.js.map